"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SpotlightHandler = {
  spotlight: null,
  register: function register(spotlight) {
    this.spotlight = spotlight;
  },
  unregister: function unregister() {
    this.spotlight = null;
  },
  show: function show(target) {
    var targetDOM = null;
    try {
      targetDOM = _reactDom["default"].findDOMNode(target);
    } catch (error) {
      console.log(error);
    }
    if (this.spotlight !== null && targetDOM !== null) {
      this.spotlight.show(targetDOM);
    }
  },
  hide: function hide() {
    if (this.spotlight !== null) {
      this.spotlight.hide();
    }
  },
  isShowing: function isShowing() {
    return this.spotlight.state.visible;
  }
};
var _default = exports["default"] = SpotlightHandler;